var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsNumber, IsObject, IsOptional, IsUUID, } from 'class-validator';
import { CustomFormFullSizeDto } from '../../custom-form/dto/custom-form.full-size.dto.js';
import { ExerciseProgramFullSizeDto } from '../../exercise-programs/dtos/exercise-program.full-size.dto.js';
import { ExerciseTemplateFolderFullSizeDto } from '../../exercise-templates/dto/exercise-template-folder.full-size.dto.js';
import { ExerciseFullSizeDto } from '../../exercise/dtos/exercise.full-size.dto.js';
import { FeatureFlagFullSizeDto } from '../../feature-flag/dtos/feature-flag.full-size.dto.js';
import { InvoiceFullSizeDto } from '../../invoice/dtos/invoice.full-size.dto.js';
import { OfficeLocationBrandingFullSizeDto } from '../../office-location-branding/dto/office-location-branding.full-size.dto.js';
import { OfficeProductFullSizeDto } from '../../office-products/index.js';
import { ConnectedStripeAccountFullSizeDto } from '../../payment/dto/connected-stripe-account.full-size.dto.js';
import { PreventionCourseFullSizeDto } from '../../prevention-courses/dtos/prevention-course.full-size.dto.js';
import { Role } from '../../roles/index.js';
import { FileUploadFullSizeDto } from '../../user/dto/file-upload.full-size.dto.js';
import { UserFullSizeDto } from '../../user/dto/user.full-size.dto.js';
import { UserProfileDto } from '../../user/dto/user.profile.dto.js';
import { OfficeLocationFullSizeDto } from './office-location.full-size.dto.js';
export class OfficeFullSizeDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    isActive;
    users;
    officeLocations;
    fileUploads;
    sharedExercises;
    exerciseTemplateFolders;
    exerciseTemplates;
    mainAdmin;
    mainAdminId;
    hasAtLeastOneVideoCall;
    sharedPreventionCourses;
    index;
    isPinoTestOffice;
    connectedStripeAccounts;
    customForms;
    invoices;
    enabledFeatureFlags;
    officeLocationBrandings;
    featureToggles;
    officeProducts;
}
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], OfficeFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Date)
], OfficeFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], OfficeFullSizeDto.prototype, "deletedAt", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], OfficeFullSizeDto.prototype, "isActive", void 0);
__decorate([
    IsArray(),
    Type(() => UserProfileDto),
    Expose({
        groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST, Role.SUPERADMIN],
    }),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "users", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeLocationFullSizeDto),
    Expose({
        groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST, Role.SUPERADMIN],
    }),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "officeLocations", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => FileUploadFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "fileUploads", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => ExerciseFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "sharedExercises", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => ExerciseTemplateFolderFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "exerciseTemplateFolders", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => ExerciseProgramFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "exerciseTemplates", void 0);
__decorate([
    IsObject(),
    Expose({ groups: [Role.SUPERADMIN] }),
    Type(() => UserFullSizeDto),
    __metadata("design:type", Object)
], OfficeFullSizeDto.prototype, "mainAdmin", void 0);
__decorate([
    IsUUID(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeFullSizeDto.prototype, "mainAdminId", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], OfficeFullSizeDto.prototype, "hasAtLeastOneVideoCall", void 0);
__decorate([
    IsArray(),
    Type(() => PreventionCourseFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "sharedPreventionCourses", void 0);
__decorate([
    Exclude(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeFullSizeDto.prototype, "index", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], OfficeFullSizeDto.prototype, "isPinoTestOffice", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => ConnectedStripeAccountFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "connectedStripeAccounts", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => CustomFormFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "customForms", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => InvoiceFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "invoices", void 0);
__decorate([
    IsArray(),
    Type(() => FeatureFlagFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "enabledFeatureFlags", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeLocationBrandingFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "officeLocationBrandings", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "featureToggles", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => OfficeProductFullSizeDto),
    __metadata("design:type", Array)
], OfficeFullSizeDto.prototype, "officeProducts", void 0);
//# sourceMappingURL=office.full-size.dto.js.map